import { render, staticRenderFns } from "./marketplace-details-statistics-card.component.vue?vue&type=template&id=1c850806"
import script from "./marketplace-details-statistics-card.component.vue?vue&type=script&lang=js"
export * from "./marketplace-details-statistics-card.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports